import type { Dayjs } from "dayjs";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export function inTimeZone(timeZone: string, date?: Date): Dayjs {
  return dayjs(date).tz(timeZone);
}

// Compare calendar dates, not instants: the calendar's day columns and a
// post's time may be in different zones (e.g. right after the profile time
// zone changes), and dayjs's isSame(…, "day") would then shift a day.
export function isSameDay(a: Dayjs, b: Dayjs): boolean {
  return a.format("YYYY-MM-DD") === b.format("YYYY-MM-DD");
}

export function formatTimeZone(timeZone: string): string {
  const city = timeZone.split("/").pop()?.replaceAll("_", " ");
  const offset = inTimeZone(timeZone)
    .format("Z")
    .replace(/^([+-])0?/, "$1");

  return `GMT${offset.replace(/:00$/, "")} (${city})`;
}
